/**
 * Contract for the liveness probe, plus the constants that pin down where the
 * API lives. Everything under `API_BASE_PATH` is the backend's; everything else
 * belongs to the frontend.
 */
/** Every API route is mounted under this prefix. Nothing else may be. */
export const API_BASE_PATH = '/api';
//# sourceMappingURL=health.js.map